import Styled from 'styled-components'

export default Styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`



// WEBPACK FOOTER //
// ./src/components/NavigationModes/index.js